<template>
    <div :key="rowId">
        <VJoyBadge bulletpoint :variant="statusVariant" :label="t(`projectclient.projectview.invoices.table.column.status.${status}`)" />
    </div>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyBadge, type TJoyBadgeVariants} from '@maltjoy/core-vue';
    import {ProjectInvoiceResourcePaymentStatusEnum} from '@api';

    const {t} = useTranslation();

    const props = defineProps<{
        rowId: string;
        status: ProjectInvoiceResourcePaymentStatusEnum;
    }>();

    const statusVariant = computed(() => {
        let variant = '' as TJoyBadgeVariants;
        switch (props.status) {
            case ProjectInvoiceResourcePaymentStatusEnum.Pending:
                variant = 'orange';
                break;
            case ProjectInvoiceResourcePaymentStatusEnum.Overdue:
                variant = 'red';
                break;
            case ProjectInvoiceResourcePaymentStatusEnum.Done:
                variant = 'green';
                break;
        }
        return variant;
    });
</script>
